import BaseBlock from "./BaseBlock";
import Swiper, { Autoplay, Navigation, Pagination, Controller } from "swiper";
import Waypoint from "../Waypoint";
import Main from "~/js/Main";
import FixedAspectRatioImg from "parent/src/js/base/Controllers/FixedAspectRatioImg";
//import YTPlayer from "yt-player";

export default class Hero extends BaseBlock {

    hasStickyContent = true;


    init() {

        // /**
        //  * @type {HTMLElement}
        //  */
        // const VideoIDEl = this.block.querySelector(".section-background #yt-player");
        // const VideoID = VideoIDEl.dataset('video-id');


        // const YTPlayer = require('yt-player')
        // const opts = {
        //     autoplay: true,
        //     controls: false,
        //     fullscreen: false,
        //     keyboard: false,
        //     captions: false,
        //     modestBranding: false,
        //     related: false,
        //     loop: 1,

        // };
        // const player = new YTPlayer('#yt-player', opts)
        // player.load('9xwazD5SyVg', [true]);


        /**
         * @type {HTMLElement}
         */
        const backgroundSliderEl = this.block.querySelector(".section-background .swiper");
        /**
         * @type {HTMLElement}
         */
        const contentSliderEl = this.block.querySelector(".section-content .swiper");

        if (backgroundSliderEl && contentSliderEl) {
            const backgroundSlider = new Swiper(backgroundSliderEl, {
                loop: true,
                spaceBetween: 40,
                speed: parseInt(contentSliderEl.dataset.swiperSpeed),
                navigation: {
                    prevEl: this.block.querySelector(".section-content .slider-btn-prev"),
                    nextEl: this.block.querySelector(".section-content .slider-btn-next"),
                },
                pagination: {
                    el: this.block.querySelector(".section-content .slider-pagination")
                },
                autoplay: {
                    delay: parseInt(contentSliderEl.dataset.swiperDelay),
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                },
                modules: [Autoplay, Navigation, Pagination, Controller]
            });

            const contentSlider = new Swiper(contentSliderEl, {
                loop: true,
                spaceBetween: 40,
                speed: parseInt(contentSliderEl.dataset.swiperSpeed),
                navigation: {
                    prevEl: this.block.querySelector(".section-content .slider-btn-prev"),
                    nextEl: this.block.querySelector(".section-content .slider-btn-next"),
                },
                pagination: {
                    el: this.block.querySelector(".section-content .slider-pagination")
                },
                autoplay: {
                    delay: parseInt(contentSliderEl.dataset.swiperDelay),
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                },
                modules: [Autoplay, Navigation, Pagination, Controller]
            });

            contentSlider.controller.control = backgroundSlider;
        }

        /**
         *
         * @type {HTMLElement}
         */
        this.formHolderEl = this.block.querySelector(".form-wrapper");

        /**
         *
         * @type {HTMLElement}
         */
        this.backgroundEl = this.block.querySelector(".section-background");

        /**
         *
         * @type {HTMLElement}
         */
        this.contentEl = this.block.querySelector(".section-content");

        if (this.formHolderEl && this.formHolderEl.classList.contains("fixed")) {
            /**
             * @type {HTMLElement}
             */
            this.formColEl = this.formHolderEl.parentElement;

            window.addEventListener("resize", () => {
                this.adjustFormPositionAndSize();
            });
            window.addEventListener("scroll", () => {
                this.adjustFormPositionAndSize();
            }, {
                passive: true
            });
            window.addEventListener("load", () => {
                this.adjustFormPositionAndSize();
            });
        }

        if (this.backgroundEl !== null && this.block.classList.contains("blur-effect-enabled")) {
            window.addEventListener("scroll", Main.Instance.debounce(this.onWindowScroll.bind(this), 10, true), {
                passive: true
            });
        }

        if (this.contentEl) {
            if (this.hasStickyContent) {
                window.addEventListener("load", () => {
                    this.adjustStickyContentPosition();
                });
                window.addEventListener("resize", () => {
                    this.adjustStickyContentPosition();
                });
            }
        }

        if (this.contentEl && this.block.classList.contains("variant-form")) {
            const textEl = this.block.querySelector(".text");
            if (textEl) {
                const posTextEl = textEl.getBoundingClientRect();
                textEl.style.top = posTextEl.top + "px";
            }
        }
    }

    blurBackground() {
        if (!this.block.classList.contains(Waypoint.InViewClass)) {
            return;
        }

        const backgroundImageEl = this.backgroundEl.querySelector('.background-image');

        if (!backgroundImageEl) {
            return;
        }

        const scroll = window.scrollY;
        const scrollPers = scroll / document.body.scrollHeight / 2;

        if (scroll > 0) {
            backgroundImageEl.style.filter = `blur(${50 * scrollPers}px)`;
            backgroundImageEl.style.transform = `scale(${1 + scrollPers})`;
        } else {
            backgroundImageEl.style = null;
        }
    }

    adjustFormPositionAndSize() {
        const computed = window.getComputedStyle(this.formHolderEl);
        if (computed.position === "fixed") {
            const formHeight = this.formHolderEl.clientHeight;
            const headerHeight = Main.Instance.getHeaderController().getHeight();
            const contentHeight = document.getElementById("SiteContent").clientHeight;
            const scroll = window.scrollY;
            const limit = headerHeight + contentHeight - formHeight;
            let top = this.formColEl.getBoundingClientRect().top;
            if (scroll > limit) {
                top = -(scroll - limit);
            } else if (scroll > top) {
                top = headerHeight;
            }

            this.formHolderEl.style.top = (top).toString().concat("px");
            this.formHolderEl.style.width = (this.formColEl.clientWidth).toString().concat("px");
        } else {
            this.formHolderEl.style = null;
        }
    }

    adjustStickyContentPosition() {
        const sectionContentCompStyle = window.getComputedStyle(this.contentEl);
        if (sectionContentCompStyle.position !== "sticky") {
            return;
        }

        const header = document.getElementById("SiteHeader");
        this.block.removeAttribute("style");
        this.contentEl.removeAttribute("style");
        if (document.body.classList.contains("desktop")) {
            window.setTimeout(() => {
                if (this.block.classList.contains("has-background")) {
                    if (this.block.classList.contains('fullscreen')) {
                        this.contentEl.style.top = header.offsetHeight + (this.block.clientHeight / 2) - (this.contentEl.clientHeight / 2) + "px";
                    } else if (!this.block.classList.contains("has-background-video")) {
                        let space = 40;
                        if (window.matchMedia('(min-width:768px)').matches) {
                            space = 80;
                        }
                        let hContent = this.contentEl.clientHeight;
                        if (!this.maintainAspectRatio) {
                            this.block.style.height = hContent + space * 2 + "px";
                        } else if (this.fixedAspectRatioImg) {
                            this.block.style.height = Math.round(this.fixedAspectRatioImg.getRealHeight()).toString().concat("px");
                        }
                        this.block.style.paddingTop = "0px";
                        this.block.style.paddingBottom = "0px";
                        this.contentEl.style.top = header.offsetHeight + space + "px";
                    }
                }
            }, 300);
        }
    }

    updateSize() {
        // do nothing
    }

    /**
     * @param {Event} e
     */
    onWindowScroll(e) {
        this.blurBackground();
    }
}